import {Router, useLocation, useRouter} from "wouter";
import {PropsWithChildren} from "react";

const NestedRoutes = (props: NestedRoutesProps) => {
    const router = useRouter();
    const [parentLocation] = useLocation();

    const nestedBase = `${router.base}${props.base}`;

    // don't render anything outside the scope
    if (!parentLocation.startsWith(nestedBase)) return null;

    // we need a key to make sure the router will remount when the base has changed
    return (
        <Router base={nestedBase} key={nestedBase}>
            {props.children}
        </Router>
    );
};

export type NestedRoutesProps = PropsWithChildren<{
    base: string,
}>

export default NestedRoutes;